import { debounce } from '@gem/utils';

import { turnNotificationInGroup } from 'APP/model/group/groupModel';
import Entities from 'STORE';

const TOGGLE_NOTIFICATIONS_DELAY = 2000;

const debouncedTurnNotificationInGroup = debounce((groupId: string, mute: boolean) => {
  turnNotificationInGroup(groupId, mute);
}, TOGGLE_NOTIFICATIONS_DELAY);

export function toggleNotifications(groupId: string): void {
  const group = Entities.GroupsStore.getGroupById(groupId);
  group?.muted ? unMuteNotifications(groupId) : muteNotifications(groupId);
}

export function muteNotifications(groupId: string): void {
  const group = Entities.GroupsStore.getGroupById(groupId);

  if (!group) {
    return;
  }

  group.muted = true;

  debouncedTurnNotificationInGroup(groupId, group.muted);
}

export function unMuteNotifications(groupId: string): void {
  const group = Entities.GroupsStore.getGroupById(groupId);

  if (!group) {
    return;
  }

  group.muted = false;

  debouncedTurnNotificationInGroup(groupId, group.muted);
}
